<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <img [src]=params.img.src [alt]=params.img.alt [class]="classPrefix('Pod0Img0')">
    <i (click)="openFileBrowserToUploadFile()" [class]="classPrefix('Pod0Icon0') + 'fa-solid fa-camera'"></i>
  </section>
</div>
<input #fileInput [class]="classPrefix('MainInput0')" type="file" multiple/>
